document.addEventListener('DOMContentLoaded', () => {
  // adding event handler to predictive search icon
  const predictiveSearchForm = document.querySelector('.predictive-search-input-form-main form');
  const predictiveSearchButton = document.querySelector(`.predictive-search-input-form-main form > div`);
  if (predictiveSearchForm && predictiveSearchButton.classList.contains('#search-popup-icon')) {
    predictiveSearchButton.addEventListener('click', () => {
      predictiveSearchForm.submit();
    });
  }
});

// PLP collection collapse
function collectionTitleClickHandler() {
  if (window.innerWidth < 992) {
    document.querySelectorAll('.filter-cat-title').forEach(function(title) {
      title.addEventListener('click', function() {
        var filterList = title.nextElementSibling;

        if (filterList && filterList.classList.contains('collection-filter-list')) {
          if (filterList.classList.contains('mobile-collapse-active')) {
            filterList.style.maxHeight = null;
            filterList.classList.remove('mobile-collapse-active');
            this.classList.remove('mobile-collapse-active');
          } else {
            filterList.style.maxHeight = filterList.scrollHeight + "px";
            filterList.classList.add('mobile-collapse-active');
            this.classList.add('mobile-collapse-active');
          }
        }
      });
    });
  }
}
document.addEventListener('DOMContentLoaded', function() {
  collectionTitleClickHandler();
});



const bodyElement = document.body;
const htmlElement = document.documentElement;

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.attributeName === 'class') {
      const classList = bodyElement.classList;
      if (classList.contains('upcartPopupShow')) {
        htmlElement.classList.add('upcartPopupShow');
      } else {
        htmlElement.classList.remove('upcartPopupShow');
      }
    }
  });
});

const config = { attributes: true };
observer.observe(bodyElement, config);